import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import { useNavigate } from 'react-router-dom';
import { COUNTRY_DIALS } from '../../utils/countryDialCodes';

type CountryBlockedPageProps = {
  countryCode?: string | null;
};

const CountryBlockedPage: React.FC<CountryBlockedPageProps> = ({ countryCode }) => {
  const navigate = useNavigate();
  const countryName = COUNTRY_DIALS.find((country) => country.iso === countryCode)?.name;
  const hideAdminSignIn = countryCode === 'PK' || countryCode === 'BD';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        background: '#0b1220',
      }}
    >
      <Box sx={{ maxWidth: 460, textAlign: 'center' }}>
        <PublicOffIcon sx={{ fontSize: 48, color: '#f87171', mb: 2 }} />
        <Typography sx={{ color: '#f8fafc', fontWeight: 700, fontSize: 28, mb: 1 }}>
          Not available in your country
        </Typography>
        <Typography sx={{ color: '#94a3b8', fontSize: 15, lineHeight: 1.6 }}>
          {countryName
            ? `This site cannot be used from ${countryName}.`
            : 'This site cannot be used from your country.'}
        </Typography>
        {!hideAdminSignIn && (
          <Button
            onClick={() => navigate('/login-administrator')}
            sx={{ mt: 3, color: '#94a3b8', textTransform: 'none' }}
          >
            Administrator sign in
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default CountryBlockedPage;
